import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoReplay3 from '@/components/UI/svg/Icons/EFVideoReplay3';
import EFVideoReplay4 from '@/components/UI/svg/Icons/EFVideoReplay4';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function MhA() {
    const { useState, useLang, useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('waveportableairconditioner');
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const Wave_WIP_pcMap: any = {
        us: ['/video/Mh200/Wave_WIP_pc.webm', '/video/Mh200/Wave_WIP_pc.mp4'],
        cn: ['/video/Mh200/Wave_WIP_pc_cn.webm', '/video/Mh200/Wave_WIP_pc_cn.mp4'],
        au: ['/video/Mh200/Wave_WIP_pc_au.webm', '/video/Mh200/Wave_WIP_pc_au.mp4'],
        ca: ['/video/Mh200/Wave_WIP_pc_au.webm', '/video/Mh200/Wave_WIP_pc_au.mp4'],
    };

    const videoPath = isMobile ? ['/video/Mh200/Wave_WIP_h5.webm', '/video/Mh200/Wave_WIP_h5.mp4'] : Wave_WIP_pcMap[locale] || Wave_WIP_pcMap.us;

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/i139iAjzctY',
        jp: 'https://www.youtube.com/embed/kvoXYzmCASY',
        au: 'https://www.youtube.com/embed/UNUkNyS4wEE',
        cn: {
            SD: 'https://videos.ecoflow.com/2f5206262d224510a274e0afed44a666/9e72665580b948eab1cd30a4c02098e9-0a99630d83f39aff10de623faf343f15-fd.mp4',
            HD: 'https://videos.ecoflow.com/2f5206262d224510a274e0afed44a666/9e72665580b948eab1cd30a4c02098e9-8099c232fe3936a07742c5c589aac5f7-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/1291a900-182ede73622-0004-9c91-e6d-40030.mp4',
        },
    };

    return (
        <>
            <div className={`${css.mhC} mhC ${isMobile ? 'mhC-h5' : 'mhC-pc'}`}>
                <div className="airPro-inter">
                    <EFVideo className="video" sources={videoPath} />
                    <div className="v-msg">
                        <div className="v-msg-inter">
                            <div className="v-msg-imgbox1">{t('mh200.mhC_title')}</div>
                            <div className="v-msg-imgbox2" onClick={() => setShowEFVideoModal(true)}>
                                {t('mh200.watch_video')}
                                {isMobile ? <EFVideoReplay4 className="arrow-triangle-right" /> : <EFVideoReplay3 className="arrow-triangle-right" />}
                            </div>
                        </div>
                    </div>
                    <div className="layout-in"></div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </>
    );
}
